export const absencesEndpoints = {
  getAbsences: '/api/absences/me',
  // getAbsencesByYear: (year: string) => `/api/absences/year/${year}`,
  // justifyAbsence: (id: string) => `/api/absences/${id}/justify`,
  // declareAbsence: '/api/absences/declare',
};
